import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Redirect, useHistory } from 'react-router-dom';

import { PrimaryButton } from '@/components';
import { ApiTransactionAPIModelStatusEnum as TransactionAPIModelStatusEnum } from '@/generated/api/fps/core';
import { WalletUIState } from '@/model/wallets/types';
import HistoryOptions from '@/pages/wallets/components/HistoryOptions';
import { useTransaction } from '@/pages/wallets/components/TransactionPageView/hooks';
import { FailedView, SuccessView } from '@/pages/withdrawal/pages/StatusPage/components';

export interface TransactionPageViewProps {
  'data-test'?: string;
  transactionId: number;
  basePath: string;
  hideDetailsLink?: boolean;
}

const TransactionPageView: React.FC<TransactionPageViewProps> = ({
  transactionId,
  basePath,
  hideDetailsLink,
  'data-test': dataTest,
}) => {
  const history = useHistory();
  const doRedirectToTransactions = useCallback(
    () => history.push(`/${basePath}/${WalletUIState.TRANSACTIONS}#tx-row-${transactionId}`),
    [basePath, history, transactionId],
  );
  const { transaction, status } = useTransaction(transactionId);

  if (!transaction) {
    return <Redirect to={`/${basePath}/${WalletUIState.TRANSACTIONS}#tx-row-${transactionId}`} />;
  }

  return status === TransactionAPIModelStatusEnum.Finished ? (
    <SuccessView
      data-test={dataTest}
      basePath={basePath}
      transaction={transaction}
      Options={!hideDetailsLink ? HistoryOptions : undefined}
      action={{ title: <FormattedMessage id="demo.pages.transaction.submit.title" />, run: doRedirectToTransactions }}
    />
  ) : (
    <FailedView
      data-test={dataTest}
      transaction={transaction}
      status={status}
      action={
        <PrimaryButton
          title={<FormattedMessage id="demo.pages.transaction.submit.title" />}
          onClick={doRedirectToTransactions}
        />
      }
    />
  );
};

export default TransactionPageView;
